<template>
  <!-- Updated Copy of CRMUserThumbnails -->
  <div v-if="users.length > 0">
    <span v-for="(user, index) in users" :key="index">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-avatar
            v-if="index <= limit - 1"
            :size="size"
            v-on="on"
            style="margin-right: -5px; border: #efefef 16px;"
          >
            <v-img :src="user.picture"> </v-img>
          </v-avatar>
        </template>
        <span>{{ user.name }}</span>
      </v-tooltip>
    </span>
    <a
      v-if="seeMoreValue"
      class="pointer font-1 blue--text link font-weight-bold ml-2"
      @click="displayDialog = true"
    >
      <v-icon v-text="$getIcon('mdiPlus')" size="15"> </v-icon>
      {{ seeMoreValue }} more
    </a>
    <v-dialog v-model="displayDialog" max-width="700" persistent>
      <v-card tile>
        <vue-card-title
          :title="thumbnailInfo"
          :subtitle="thumbnailInfo"
          closable
          persistent
          @close="displayDialog = false"
        >
        </vue-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col
              v-for="(user, index) in users"
              :key="index"
              class="my-3"
              md="4"
            >
              <v-avatar :size="size">
                <v-img :src="user.picture"> </v-img>
              </v-avatar>
              <span class="font-weight-bold pl-2">{{ user.name }}</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
  <div v-else>
    <span class="grey--text">{{ noDataValue }}</span>
  </div>
</template>
<script>
export default {
  props: {
    users: {
      type: Array,
      required: true
    },
    size: {
      type: Number,
      required: false,
      default: 30
    },
    limit: {
      type: Number,
      required: false,
      default: 3
    },
    noDataValue: {
      type: String,
      required: false,
      default: "No users found."
    },
    thumbnailInfo: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      displayDialog: false
    };
  },
  computed: {
    seeMoreValue() {
      let value = 0;
      if (this.users.length > this.limit) {
        value = this.users.length - this.limit;
      }
      return value;
    }
  }
};
</script>
